import idx from 'idx'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, withHandlers } from 'recompose'

import * as routeActions from 'actions/routeActions'
import * as userActions from 'actions/userActions'

export default compose(
  connect(
    (state) => {
      return {
        hasError: idx(state, _ => _.progress.login.hasError) || false,
      }
    },
    (dispatch) => {
      const actions = {
        ...routeActions,
        ...userActions,
      }

      return {
        actions: bindActionCreators(actions, dispatch),
      }
    },
  ),
  // Handlers
  withHandlers({
    onLoginSubmit: props => (loginFields) => {
      props.actions.loginUser(loginFields)
    }
  }),
)



// WEBPACK FOOTER //
// ./src/containers/account/Login/Login.enhancer.js